var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.flashMessages)?_c('div',{staticClass:"messages"},_vm._l((_vm.flashMessages),function(flashMessage,index){return _c('toaster-message',{key:index,attrs:{"flashMessage":flashMessage}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }